import { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useToken } from "./tokenContext";
import useApi from "./apiService";

const FeatureContext = createContext();

export const FeatureProvider = ({ children }) => {
  const { fetchData } = useApi();
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const { token } = useToken();

  const fetchFeatures = async () => {
    try {
      const response = await fetchData("features");
      const enabledFeatures = response.data.filter(
        (feature) => feature.is_enabled === true,
      );
      setFeatures(enabledFeatures);
    } catch (error) {
      console.error("Error fetching features:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!token) {
      setLoading(true);
      return;
    }

    fetchFeatures();
  }, [token]);

  const findFeatureBySlug = (slug) => {
    return features.find((feature) => feature.slug === slug);
  };
  const hasFeatureBySlug = (slug) => {
    return features.some((feature) => feature.slug === slug);
  };

  const refreshFeatures = () => {
    if (token) fetchFeatures();
  };

  return (
    <FeatureContext.Provider
      value={{
        features,
        loading,
        findFeatureBySlug,
        hasFeatureBySlug,
        refreshFeatures,
      }}
    >
      {children}
    </FeatureContext.Provider>
  );
};

FeatureProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useFeature = () => useContext(FeatureContext);
